import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const StyledNoLearnerMsg = styled(TextV2)(({ theme }) => ({
  paddingTop: theme.spacing(spacingSizeMap.S),
}));

const LearnersListEmptyMsg = () => {
  const { t } = useTranslation();
  return (
    <StyledNoLearnerMsg>
      {t('ui.event-management.learners.teams.no-learners')}
    </StyledNoLearnerMsg>
  );
};

export default LearnersListEmptyMsg;
